export default {
  inhabitantChange: 0
};
